export default __webpack_public_path__ + "static/wave-white-inverted-cc4c4fe69f0c9d8e51438069af05ecc6.svg";